import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  about: {
    id: 'location.profile.about',
    description: 'about summary section heading',
    defaultMessage: 'About'
  }
});
